import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useRouter } from 'next/router'
import { ICurrentGeo } from '../../../model/Common/common.interface'
import { currentGeoQueryApi } from '../../react-query/queryApis'

export const useCurrentGeo = () => {
  const router = useRouter()
  router.asPath.includes('/caf/')
  return useQuery<ICurrentGeo, AxiosError>({
    queryKey: currentGeoQueryApi.getQueryKey(),
    queryFn: currentGeoQueryApi.getQueryFn(),
    enabled: !router.asPath.includes('/caf/'),
  })
}
